import { useState, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { AccumulativeShadows, RandomizedLight } from '@react-three/drei';

const ShadowHandler = ({ isBaked, setIsBakingParent }) => {
  const [isBaking, setIsBaking] = useState(false);
  const accumulativeShadowsRef = useRef();
  const targetFrames = 100;
  const frameCountRef = useRef(0);

  const handleFrameCompletion = () => {
    setIsBaking(true);
    // Notify parent component
    if (typeof setIsBakingParent === 'function') {
      setIsBakingParent(true);
    }
  };

  useFrame(() => {
    if (!isBaking && accumulativeShadowsRef.current) {
      frameCountRef.current++;
      if (frameCountRef.current >= targetFrames) {
        handleFrameCompletion();
      }
    }
  });

  // Note: AccumulativeShadows with 'temporal' prop will reset shadows once when objects first transform (rotate/move)
  // This causes one recalculation on first interaction, which is a limitation of drei's AccumulativeShadows
  // Removing 'temporal' causes the model to disappear on first interaction, so we must keep it
  // The shadow reset happens once, then shadows remain stable for subsequent interactions
  return (
    <>
      <AccumulativeShadows
        temporal
        frames={targetFrames}
        scale={5}
        opacity={1}
        resolution={2048}
        ref={accumulativeShadowsRef}
      >
        <RandomizedLight
          amount={2}
          position={[0, 1, 0]}
          radius={5}
        />
      </AccumulativeShadows>
    </>
  );
};

export default ShadowHandler;
